module.exports = __webpack_public_path__ + "img/new_icon2.22c2a3b.png";